import React, { useEffect, useState } from "react";
import CustomInput from "../Custom/CustomInput";
import axios from "axios";
import { useDispatch } from "react-redux";
import allActions from "../../Action/allActions";
import cookie from "js-cookie";
import CustomButton from "../Custom/CustomButton";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [saveIsLoading, setSaveIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    password: "",
    password_confirmation: "",
  });

  const resetForm = () => {
    setFormData({
      name: "",
      username: "",
      email: "",
      password: "",
      password_confirmation: "",
    });
    setError("");
  };

  useEffect(() => {
    resetForm();
  }, []);

  const handleInputChange = (event) => {
    const { id, value } = event.target;
    setFormData({
      ...formData,
      [id]: value,
    });
    setError("");
  };

  const OnClickRegister = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name || !formData.username || !formData.email || !formData.password) {
      setError("All fields are required");
      return;
    }

    if (formData.password !== formData.password_confirmation) {
      setError("Passwords do not match");
      return;
    }

    if (formData.password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    setSaveIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/signup`,
        {
          name: formData.name,
          username: formData.username,
          email: formData.email,
          password: formData.password,
        }
      );

      let data = response.data;

      // Handle BOM in response
      if (typeof data === "string") {
        const jsonStart = data.indexOf("{");
        if (jsonStart > 0) {
          data = JSON.parse(data.substring(jsonStart));
        } else {
          data = JSON.parse(data);
        }
      }

      if (data.success) {
        // Store JWT token
        cookie.set("token", data.token);
        axios.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;

        // Dispatch user to Redux
        dispatch(
          allActions.userActions.setUser({
            id: data.user_id,
            username: data.username,
            email: data.email,
            name: data.name,
          })
        );

        toast.success("Account created successfully!");
        resetForm();
        setSaveIsLoading(false);
        navigate("/ShoppingCart");
      } else {
        setError(data.error || "Signup failed");
        setSaveIsLoading(false);
      }
    } catch (error) {
      console.log("Error:", error);
      if (error?.response?.status === 409) {
        setError("Email or username already exists");
      } else {
        setError(error.response?.data?.error || "Signup failed");
      }
      setSaveIsLoading(false);
    }
  };

  return (
    <div>
      <div className="SignIn-div1">
        <p className="SignIn-Title">New customer</p>
      </div>
      <p className="SignIn-descp">
        Create an account and access exclusive offers. Track your orders and manage
        your preferences.
      </p>

      {error && <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>}

      <CustomInput
        placeholder={"Full Name"}
        onChange={handleInputChange}
        id={"name"}
        value={formData.name}
        type="text"
      />
      <CustomInput
        placeholder={"Username"}
        onChange={handleInputChange}
        id={"username"}
        value={formData.username}
        type="text"
      />
      <CustomInput
        placeholder={"Email"}
        onChange={handleInputChange}
        id={"email"}
        value={formData.email}
        type="email"
      />
      <CustomInput
        placeholder={"Password"}
        onChange={handleInputChange}
        id={"password"}
        value={formData.password}
        type="password"
      />
      <CustomInput
        placeholder={"Confirm Password"}
        onChange={handleInputChange}
        id={"password_confirmation"}
        value={formData.password_confirmation}
        type="password"
      />

      <div style={{ marginTop: "20px" }}>
        <button
          type="submit"
          onClick={OnClickRegister}
          disabled={saveIsLoading}
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: saveIsLoading ? "#ccc" : "#667eea",
            color: "white",
            border: "none",
            borderRadius: "5px",
            fontSize: "16px",
            fontWeight: "600",
            cursor: saveIsLoading ? "not-allowed" : "pointer",
          }}
        >
          {saveIsLoading ? "Creating Account..." : "Sign Up"}
        </button>
      </div>
    </div>
  );
};

export default Register;